export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const LOGIN_PATH = "/auth/login";
export const PUBLIC_PATHS = ["/login", "/sign-up", "/forgot-password"];
export const REFRESH_URL = "/api/auth/refresh";